module.exports = __webpack_public_path__ + "static/snow-e8093550aad29a7d4b156229317a3e76.jpg";